// In-game HUD help strings (English) — the settings modal, shortcuts,
// help modal and footer sections, split out of gameEn.ts so each file
// stays under the 400-line limit. Merged into the dictionaries in
// ./messages.ts alongside the core table.

export const gameHelpEn = {
  // Settings modal
  'settings.tab.audio': 'Audio',
  'settings.tab.controls': 'Controls',
  'settings.tab.graphics': 'Graphics',
  'settings.tab.gameplay': 'Gameplay',
  'settings.mute': 'Mute',
  'settings.unmute': 'Unmute',
  'settings.audio.master': 'Master',
  'settings.audio.music': 'Music',
  'settings.audio.sfx': 'SFX',
  'settings.controls.title': 'Keyboard & Mouse',
  'settings.controls.scrollSpeed': 'Scroll Speed',
  'settings.controls.rebindSoon': 'Key rebinding is coming in a future update.',
  'settings.graphics.title': 'Display',
  'settings.graphics.clouds': 'Clouds',
  'settings.graphics.cloudsHint': 'Drifting clouds and their soft shadows on the map',
  'settings.graphics.minimapBox': 'Minimap camera box',
  'settings.graphics.minimapBoxHint': 'Show the 3D camera footprint on the minimap',
  'settings.graphics.particles': 'Particle Effects',
  'settings.graphics.particlesHint': 'Ambient particles on the hex map',
  'settings.graphics.fauna': 'Ambient Life',
  'settings.graphics.faunaHint': 'Fish, ducks and other wildlife on the map',
  'settings.graphics.grid': 'Show Hex Grid',
  'settings.graphics.gridHint': 'Display hex borders on the map',
  'settings.graphics.doubleBoard': 'Large Board',
  'settings.graphics.doubleBoardHint': 'Render the map at twice the size with extra detail',
  'settings.graphics.hifiUnits': 'High Fidelity Units',
  'settings.graphics.hifiUnitsHint': 'Rounded, smooth-shaded unit models (more GPU)',
  'settings.graphics.unitQuality': 'Unit detail',
  'settings.graphics.unitQualityHint':
    'Voxel: blocky and cheapest. Smooth: the same units, smoothed. 3D models: authored meshes where one exists (smooth elsewhere); most GPU.',
  'settings.graphics.unitQuality.voxel': 'Voxel',
  'settings.graphics.unitQuality.smooth': 'Smooth',
  'settings.graphics.unitQuality.mesh': '3D models',
  'settings.graphics.dayNight': 'Day/Night Cycle',
  'settings.graphics.dayNightHint': 'Animate daylight and light night torches',
  'settings.graphics.territory': 'Show Territory',
  'settings.graphics.territoryHint': 'Tint and border tiles by their controlling player',
  'settings.gameplay.title': 'Gameplay',
  'settings.gameplay.autosave': 'Autosave',
  'settings.gameplay.autosaveHint': 'Automatically save each empire tick',
  'settings.gameplay.tooltips': 'Tile Tooltips',
  'settings.gameplay.tooltipsHint': 'Show info when hovering tiles',
  'settings.gameplay.pauseAway': 'Pause When Away',
  'settings.gameplay.pauseAwayHint': 'Pause single-player when you switch tabs or windows',
  'settings.gameplay.pauseDanger': 'Pause On Danger',
  'settings.gameplay.pauseDangerHint': 'Pause and show what happened when your cities are hit',
  'settings.gameplay.pauseDanger.major': 'City lost',
  'settings.gameplay.pauseDanger.all': 'Any attack',
  'settings.gameplay.combatOverlay': 'Combat Overlay',
  'settings.gameplay.combatOverlayHint': 'Ticker, modal, and on-map jitter for engagements',
  'settings.gameplay.combatOverlay.drawer': 'Drawer',
  'settings.gameplay.combatOverlay.modal': 'Modal+Drawer',
  'settings.gameplay.matchSettings': 'Match Settings',

  'match.victory': 'Victory Conditions',
  'match.tradeRoutes': 'Trade Routes',
  'match.tradeRoutesHint': 'Enable trade route victory',
  'match.formations': 'Formations',
  'match.formationsHint': 'Enable formation combat',
  'match.minEmpireTick': 'Min Empire Tick',
  'match.minEmpireTickHint': 'Minimum empire tick before non-conquest victory',
  'match.sustainTicks': 'Sustain Ticks',
  'match.sustainTicksHint': 'Consecutive empire ticks to sustain victory',
  'match.ai': 'AI Personality',
  'match.shuffleInterval': 'Shuffle Interval',
  'match.shuffleIntervalHint': 'Re-roll AI personality every N ticks (0 = disabled)',
  'match.aggressionMin': 'Aggression Range Min',
  'match.gameSpeed': 'Game Speed',
  'match.incomeInterval': 'Income Interval',
  'match.incomeIntervalHint': 'Ticks between income applications',
  'match.empireInterval': 'Empire Interval',
  'match.empireIntervalHint': 'Ticks between empire decisions',
  'match.movementReset': 'Movement Reset Interval',
  'match.movementResetHint': 'Ticks between movement resets',
  'match.slowIncome': 'Slow Income Interval',
  'match.slowIncomeHint': 'Ticks between slow income applications',
  'match.aiMove': 'AI Move Interval',
  'match.aiMoveHint': 'Ticks between AI move decisions',
  'match.siege': 'Siege',
  'match.evalInterval': 'Eval Interval',
  'match.evalIntervalHint': 'Ticks between siege evaluation checks',
  'match.moodPenalty': 'Mood Penalty',
  'match.siegeMoodPenaltyHint': 'Mood penalty per siege tick',
  'match.surrenderMood': 'Surrender Mood Threshold',
  'match.surrenderMoodHint': 'Mood threshold for surrender offer',
  'match.surrenderLoyalty': 'Surrender Loyalty Threshold',
  'match.surrenderLoyaltyHint': 'Loyalty threshold for surrender offer',
  'match.minSiegeTicks': 'Min Siege Ticks',
  'match.minSiegeTicksHint': 'Min ticks before surrender is offered',
  'match.capitalMood': 'Capital Mood Threshold',
  'match.capitalMoodHint': 'Mood threshold for capital siege surrender',
  'match.capitalMinTicks': 'Capital Min Siege Ticks',
  'match.capitalMinTicksHint': 'Min ticks before capital surrender is offered',
  'match.espionage': 'Espionage',
  'match.intelDepth1': 'Intel Delivery Depth 1',
  'match.intelDepth1Hint': 'First delivery depth',
  'match.intelDepth2': 'Intel Delivery Depth 2',
  'match.intelDepth2Hint': 'Second delivery depth',
  'match.detectAdjacent': 'Detection Adjacent',
  'match.detectAdjacentHint': 'Detection chance for adjacent tiles (%)',
  'match.detect2Hex': 'Detection 2-Hex',
  'match.detect2HexHint': 'Detection chance for 2-hex distance (%)',
  'match.bodyguard': 'Bodyguard Block',
  'match.bodyguardHint': 'Bodyguard block chance (%)',
  'match.sacrifice': 'Sacrifice',
  'match.minPopulation': 'Min Population',
  'match.minPopulationHint': 'Minimum population required to sacrifice',
  'match.faithReturn': 'Faith Return',
  'match.faithReturnHint': 'Faith return numerator/denominator',
  'match.sacrificeMoodPenaltyHint': 'Mood penalty per sacrifice',
  'match.loyaltyPenalty': 'Loyalty Penalty',
  'match.loyaltyPenaltyHint': 'Loyalty penalty per sacrifice',
  'match.combat': 'Combat',
  'match.surrenderHp': 'Surrender HP Threshold',
  'match.surrenderHpHint': 'HP percentage threshold for surrender',
  'match.conversionCost': 'Surrender Conversion Cost',
  'match.conversionCostHint': 'Conversion cost percentage',
  'match.economy': 'Economy',
  'match.baseFood': 'Base Food Per City',
  'match.baseFoodHint': 'Base food production per city',
  'match.lootGold': 'City Loot Gold Per Pop',
  'match.lootGoldHint': 'Gold per population when looting a city',
  'match.lootIndustry': 'City Loot Industry Per Tier',
  'match.lootIndustryHint': 'Industry per tier when looting a city',

  // Shortcuts (settings Controls tab + help modal)
  'keys.esc': 'Clear selection, close panels',
  'keys.debug': 'Toggle debug HUD',
  'keys.chat': 'Toggle chat (multiplayer)',

  // Help modal
  'help.title': 'How to Play',
  'help.label': 'How to play',
  'help.close': 'Close help',
  'help.controls': 'Controls',
  'help.key.clickTile': 'Click tile',
  'help.key.clickTileDesc': 'Select and show tile info',
  'help.key.clickCity': 'Click city',
  'help.key.clickCityDesc': 'Open city build/garrison panel',
  'help.key.clickUnit': 'Click unit',
  'help.key.clickUnitDesc': 'Select unit, show abilities',
  'help.key.rightClick': 'Right-click tile',
  'help.key.rightClickDesc': 'Move selected unit',
  'help.resources': 'Resources',
  'help.res.food': 'Food',
  'help.res.foodDesc': 'Farms, pastures, fishing. Drives population growth.',
  'help.res.industry': 'Industry',
  'help.res.industryDesc': 'Mines, quarries, workshops. Builds buildings and units.',
  'help.res.knowledge': 'Knowledge',
  'help.res.knowledgeDesc':
    'Libraries, academies. Spend 150 to start 8-turn research buff (+50% industry, +30% knowledge).',
  'help.res.faith': 'Faith',
  'help.res.faithDesc':
    'Temples, shrines. Powers religious units. High faith causes crisis tension — de-escalate with Pilgrimage (100 gold) or Reform (50 faith).',
  'help.res.gold': 'Gold',
  'help.res.goldDesc':
    'Trade routes, markets, taxes. Used for buildings, pilgrimage, and diplomacy.',
  'help.combat': 'Combat Quick Tips',
  'help.combat.tip1':
    'Pike beats Cavalry (1.5x). Cavalry beats Ranged (1.4x). Ranged beats Pike (1.4x).',
  'help.combat.tip2': 'Magic beats Siege (1.4x). Siege beats Ranged (1.1x) and Buildings.',
  'help.combat.tip3': 'Defend on {hills}, {mountains}, or {cities}.',
  'help.combat.hills': 'hills (+2)',
  'help.combat.mountains': 'mountains (+3)',
  'help.combat.cities': 'cities (+2)',
  'help.combat.tip4':
    'Toggle formations per unit — Line beats Column, Wedge beats Line, Hold beats Skirmish.',
  'help.victory': 'Victory Paths',
  'help.victory.conquest': 'Own every city',
  'help.victory.economy': 'Gold + trade routes above threshold',
  'help.victory.science': 'Accumulate knowledge above threshold',
  'help.victory.faith': 'Faith + temples above threshold',
  'help.victory.diplomacy': 'Honor + alliances with all players',
  'help.fullGuide': 'Full guide:',
  'help.gotIt': 'Got it',

  // Footer hint
  'footer.togglesDebug': 'toggles debug',
  'footer.devtools': 'DevTools at',
} as const;

export type GameHelpKey = keyof typeof gameHelpEn;
